import api from './api';

const aiApi = {
  // Extraire mots-clés d'un texte (legacy)
  extractKeywords: (text) => {
    return api.post('/ai/extract-keywords', { text });
  },
  // Synthèse ultra-courte d'une demande initiale
  synthesize: (text) => {
    return api.post('/ai/synthesize', { text });
  },
  // Reformulation d'un brouillon SMS avec le contexte de la demande
  reformulerSms: (draft, demande_id) => {
    return api.post('/ai/sms-reformuler', { draft, demande_id });
  },
  // La note saisie contredit-elle la réponse « est-ce le propriétaire actuel ? »
  // Répond toujours { coherent, explication } — jamais d'erreur bloquante.
  // `nom_client` sert uniquement à l'anonymisation côté serveur : le nom est
  // remplacé par un jeton avant l'envoi à l'IA, jamais transmis tel quel.
  verifierCoherenceProprietaire: (notes, est_proprietaire_actuel, nom_client) => {
    return api.post('/ai/coherence-proprietaire', { notes, est_proprietaire_actuel, nom_client });
  },
};

export default aiApi;
